import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';

export interface IAiTemplate extends IBaseEntity {
    id: number;
    name: any;
    description: any;
    subject: any;
    htmlTemplate: any;
    entities: any;
    previewIds: any;
    images: any;
    deleted: any;
}

export class AiTemplate extends BaseEntity implements IAiTemplate {
    id: number;
    name: any;
    description: any;
    subject: any;
    htmlTemplate: any;
    entities: any;
    previewIds: any;
    images: any;
    deleted: any;

    constructor(aiTemplate?) {
        super();
        if (aiTemplate) {
            this.id = aiTemplate.id;
            this.name = aiTemplate.name;
            this.description = aiTemplate.description;
            this.subject = aiTemplate.subject;
            this.htmlTemplate = aiTemplate.htmlTemplate;
            this.entities = aiTemplate.entities;
            this.previewIds = aiTemplate.previewIds;
            this.images = aiTemplate.images;
            this.deleted = aiTemplate.deleted;
        }
    }

    clone(): AiTemplate {
        return new AiTemplate(this);
    }
}
